export class HashSet<T> {

  private hashSet = {}
  private key: string | number

  constructor(key: string | number) {
    this.key = key
  }

  add(item: T): void {
    this.hashSet[item[this.key]] = item
  }

  has(item: T): boolean {
    return !!this.hashSet[item[this.key]]
  }

  remove(item: T): boolean {
    if (!this.has(item)) {
      return false
    }
    delete this.hashSet[item[this.key]]
    return true
  }

  removeById(id: string | number): boolean {
    if (!this.hashSet[id]) {
      return false
    }
    delete this.hashSet[id]
    return true
  }

  getById(id: string | number): T | null {
    if (!this.hashSet[id]) {
      return null
    }
    return this.hashSet[id]
  }

  forEach(fn) {
    Object.values(this.hashSet).forEach(fn)
  }

  size(): number {
    return Object.keys(this.hashSet).length
  }

  clear() {
    this.hashSet = {}
  }

  toString() {
    return Object.entries(this.hashSet)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/hashset.ts